import {TableCell, Typography} from "@mui/material";
import React from "react";
import {PersonEvent, PersonEventRestControllerApiFactory,} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../../components/layout/list";
import {useApiManager} from "../../../../../components/utils/api";
import {dateFromString, dateToString} from "../../../../../components/utils/dates";
import {useParams} from "react-router-dom";
import {usePerson} from "../index";
import {personName} from "../header";
import {parsePathId} from "../../../../../components/form/form_utils";

export const PersonEventListPage = () => {
	const apiManager = useApiManager();
	const params = useParams();
	const personId = parsePathId(params, "personId", true);


	const eventApi = apiManager.factory(PersonEventRestControllerApiFactory);

	const [person, setPerson] = usePerson(personId);

	const listConfig: AppListConfig<PersonEvent> = {
		title: "Eventos de " + personName(person),
		onClick: "/app/admin/employee/person/" + personId + "/event",
		headers: [
			{title: "Fecha", width: 160},
			{title: "Descripción"},
		],
		decorator: (bean: PersonEvent) => (
			< >
				<TableCell>
					<Typography variant="body2" fontWeight={600}>{dateToString(dateFromString(bean.issueDate))}</Typography>
				</TableCell>
				<TableCell>
					<Typography variant="body2" color="text.secondary" noWrap title={bean.description}>{bean.description || "—"}</Typography>
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			if (!personId) throw new Error("No personId");
			return eventApi.pagePersonEvent(personId, currentPage, size, undefined, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};